import React from 'react'
import styled from 'styled-components'

import Purpose from './Purpose'
import Navbar from './Navbar'
import FadeIn from './FadeIn'

import { device } from '../media'

const ValueExplanation = styled(FadeIn)`
  margin-top: 0.889209325rem;
  @media ${device.mobile} {
    margin-top: 0;
  }
`

const ValuePagesTemplate = ({ children }) => (
  <div>
    <Purpose />
    <Navbar mobileDisplay='none' />
    <ValueExplanation>
      { children }
    </ValueExplanation>
  </div>
)

export default ValuePagesTemplate


// WEBPACK FOOTER //
// ./src/components/ValuePagesTemplate.js